interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

export function Skeleton({ className, style }: SkeletonProps) {
  return (
    <div
      className={`rounded-[8px] ${className ?? ''}`}
      style={{
        background:
          'linear-gradient(90deg, rgba(255,248,230,0.03) 25%, rgba(255,248,230,0.08) 50%, rgba(255,248,230,0.03) 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s ease-in-out infinite',
        ...style,
      }}
    />
  );
}

export function TaskCardSkeleton() {
  return (
    <div
      className="rounded-[14px]"
      style={{ padding: '18px 20px', border: '1px solid rgba(255,248,230,0.06)' }}
    >
      <div className="flex justify-between items-start mb-3">
        <Skeleton style={{ width: '60%', height: 16 }} />
        <Skeleton style={{ width: 70, height: 22, borderRadius: 100 }} />
      </div>
      <Skeleton style={{ width: '40%', height: 12 }} />
      <Skeleton className="mt-3" style={{ width: '100%', height: 3 }} />
    </div>
  );
}

export function ContactCardSkeleton() {
  return (
    <div
      className="flex items-center gap-4 rounded-[14px]"
      style={{ padding: '16px 20px', border: '1px solid rgba(255,248,230,0.06)' }}
    >
      <Skeleton style={{ width: 38, height: 38, borderRadius: 10, flexShrink: 0 }} />
      <div className="flex-1">
        <Skeleton style={{ width: '45%', height: 14 }} />
        <Skeleton className="mt-2" style={{ width: '65%', height: 11 }} />
        <Skeleton className="mt-1.5" style={{ width: '30%', height: 11 }} />
      </div>
    </div>
  );
}

export function TimelineSkeleton() {
  return (
    <div className="flex flex-col gap-6" style={{ paddingLeft: 20 }}>
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex items-start gap-4">
          <Skeleton style={{ width: 32, height: 32, borderRadius: '50%', flexShrink: 0 }} />
          <div className="flex-1">
            <Skeleton style={{ width: '50%', height: 14 }} />
            <Skeleton className="mt-2" style={{ width: '70%', height: 11 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function LogEntrySkeleton() {
  return (
    <div
      className="flex items-start gap-3.5 rounded-[12px]"
      style={{ padding: '14px 18px', border: '1px solid rgba(255,248,230,0.06)' }}
    >
      <Skeleton style={{ width: 56, height: 20, borderRadius: 6, flexShrink: 0 }} />
      <div className="flex-1">
        <Skeleton style={{ width: '70%', height: 14 }} />
        <Skeleton className="mt-2" style={{ width: '40%', height: 11 }} />
      </div>
    </div>
  );
}

export function SettingsCardSkeleton() {
  return (
    <div
      className="rounded-[16px]"
      style={{ padding: '24px 28px', border: '1px solid rgba(255,248,230,0.06)' }}
    >
      <Skeleton style={{ width: 100, height: 12 }} className="mb-4" />
      <Skeleton style={{ width: '40%', height: 20 }} className="mb-3" />
      <Skeleton style={{ width: '60%', height: 12 }} />
    </div>
  );
}
